import React, { useState, useRef, useLayoutEffect } from "react";
import "./index.scss";
import AdjuntarDocumentacionComponent from "../../../components/hb/adjuntar-documentacion";

const AdjuntarDocumentacion = () => {
  
  const ref = useRef(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    setHeight(ref.current.clientHeight);
  }, []);

  return (
    <div className="d-flex help-page" ref={ref}>
      <AdjuntarDocumentacionComponent />
    </div>
  );
};

export default AdjuntarDocumentacion;
